var React = require('react');

function IcoLocationSharp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.5 1.5625C8.18701 1.5625 4.6875 4.7124 4.6875 8.59375C4.6875 14.8438 12.5 23.4375 12.5 23.4375C12.5 23.4375 20.3125 14.8438 20.3125 8.59375C20.3125 4.7124 16.813 1.5625 12.5 1.5625ZM12.5 12.5C11.8819 12.5 11.2777 12.3167 10.7638 11.9733C10.2499 11.63 9.8494 11.1419 9.61288 10.5709C9.37635 9.99987 9.31447 9.37153 9.43505 8.76534C9.55562 8.15915 9.85325 7.60233 10.2903 7.16529C10.7273 6.72825 11.2842 6.43062 11.8903 6.31005C12.4965 6.18947 13.1249 6.25135 13.6959 6.48788C14.2669 6.7244 14.755 7.12494 15.0983 7.63884C15.4417 8.15275 15.625 8.75693 15.625 9.375C15.6241 10.2035 15.2946 10.9979 14.7087 11.5837C14.1229 12.1696 13.3285 12.4991 12.5 12.5Z","fill":"currentColor"}));
}

IcoLocationSharp.defaultProps = {"viewBox":"0 0 25 25","fill":"none"};

module.exports = IcoLocationSharp;

IcoLocationSharp.default = IcoLocationSharp;
